<template>
  <div class="login">
    <van-nav-bar title="账号登录" @click-left="$router.go(-1)" :safe-area-inset-top="true" />
    <div class="container">
      <div class="title">
        <h3>智慧平台</h3>
      </div>
    </div>
    <van-form @submit="login">
      <van-field v-model="username" name="username" label="手机号" placeholder="手机号"
        :rules="[{ required: true, message: '请填写手机号' }]" />
      <van-field v-model="password" type="password" name="password" label="密码" placeholder="密码"
        :rules="[{ required: true, message: '请填写密码' }]" />
      <van-field name="identify" label="角色">
        <template #input>
          <van-radio-group v-model="identify" direction="horizontal">
            <van-radio name="parents" shape="square">家长</van-radio>
            <van-radio name="teacher" shape="square">教师</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">登录</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { codeLogin } from '@/api/login'

export default {
  name: 'LoginIndex',
  data () {
    return {
      username: '',
      password: '',
      identify: 'parents'
    }
  },
  methods: {
    async login () {
      if (!this.validFn()) {
        return
      }
      const res = await codeLogin(this.username, this.password, this.identify)
      if(res.code !== 10000){
        // this.$toast.fail(res.message)
        return
      }
      this.$store.commit('user/setUserInfo', res.data)
      this.$toast('登录成功')
      // const url = this.$route.query.backUrl || '/'
      // this.$router.replace(url)
      if(res.data.identify === 'parents'){
        this.$router.replace('/home')
      }else{
        this.$router.replace('/thome')
      }
    },
    // 校验输入框内容
    validFn () {
      if (!/^1[1-9]\d{9}$/.test(this.username)) {
        this.$toast('请输入正确的手机号')
        return false
      }
      return true
    }
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 49px 29px;

  .title {
    margin-bottom: 20px;

    h3 {
      font-size: 26px;
      font-weight: normal;
    }

    p {
      line-height: 40px;
      font-size: 14px;
      color: #b8b8b8
    }
  }
}

.form-item {
  border-bottom: 1px solid #f3f1f2;
  padding: 8px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;

  .inp {
    display: block;
    border: none;
    outline: none;
    height: 32px;
    font-size: 14px;
    flex: 1;
  }

  img {
    width: 94px;
    height: 31px;
  }

  button {
    height: 31px;
    border: none;
    font-size: 13px;
    color: #cea26a;
    background-color: transparent;
    padding-right: 9px;
  }
}

.login-btn {
  width: 100%;
  height: 42px;
  margin-top: 39px;
  background: linear-gradient(90deg, #ecb53c, #ff9211);
  color: #fff;
  border-radius: 39px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, .1);
  letter-spacing: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
